import { render, staticRenderFns } from "./ContractAdmin.vue?vue&type=template&id=bc7d4942&"
import script from "./ContractAdmin.vue?vue&type=script&lang=ts&"
export * from "./ContractAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports